import { Box, Divider, Typography } from "@mui/material"
import type { FC } from "react"
import React from "react"

import { CompanyEquipment, CompanyIndustry, CompanyMarket } from "@/graphql/codegen/graphql"
import CompanyInfoSelect from "@/screens/Companies/edit/components/info/components/form/CompanyInfoSelect"
import CompanyInfoTextArea from "@/screens/Companies/edit/components/info/components/form/CompanyInfoTextArea"
import { COMPANY_INFO_TEXT_AREA_MAX_SIZE } from "@/screens/Companies/edit/components/info/constants"
import {
  CompanyEquipmentLabelMap,
  CompanyIndustryLabelMap,
  CompanyMarketLabelMap,
} from "@/screens/Companies/edit/components/info/utils/companyInfoDataMap"

const CompanyMarketOptions = Object.values(CompanyMarket).map((value) => ({
  value: value.toString(),
  label: CompanyMarketLabelMap.get(value) ?? value,
}))

const CompanyIndustriesOptions = Object.values(CompanyIndustry).map((value) => ({
  value: value.toString(),
  label: CompanyIndustryLabelMap.get(value) ?? value,
}))

const CompanyEquipmentOptions = Object.values(CompanyEquipment).map((value) => ({
  value: value.toString(),
  label: CompanyEquipmentLabelMap.get(value) ?? value,
}))

interface CompanyInfoFormProps {
  isEditMode: boolean
}

const CompanyInfoForm: FC<CompanyInfoFormProps> = ({ isEditMode }) => {
  return (
    <form>
      <CompanyInfoSelect
        name='industry'
        options={CompanyIndustriesOptions}
        title='Industries'
        isEditMode={isEditMode}
      />

      <CompanyInfoSelect name='market' options={CompanyMarketOptions} title='Markets' isEditMode={isEditMode} />

      <CompanyInfoSelect name='equipment' options={CompanyEquipmentOptions} title='Equipment' isEditMode={isEditMode} />

      <Box className='relative mt-6'>
        <Typography variant='subtitle1' className='text-ml'>
          General Info
        </Typography>

        <CompanyInfoTextArea isEditMode={isEditMode} name='generalInfo' maxLength={COMPANY_INFO_TEXT_AREA_MAX_SIZE} />
      </Box>

      <Box className='relative mt-6'>
        <Typography variant='subtitle1' className='text-ml'>
          Evaluation
        </Typography>
        <Divider className='my-4' />

        <Box className='mt-6'>
          <CompanyInfoTextArea
            isEditMode={isEditMode}
            name='marketingPotential'
            label='Marketing Potential'
            maxLength={COMPANY_INFO_TEXT_AREA_MAX_SIZE}
          />
        </Box>

        <Box className='mt-6'>
          <CompanyInfoTextArea
            isEditMode={isEditMode}
            name='technicalCapabilities'
            label='Technical Capabilities'
            maxLength={COMPANY_INFO_TEXT_AREA_MAX_SIZE}
          />
        </Box>
        <Box className='mt-6'>
          <CompanyInfoTextArea
            isEditMode={isEditMode}
            name='productionCapabilities'
            label='Production Capabilities'
            maxLength={COMPANY_INFO_TEXT_AREA_MAX_SIZE}
          />
        </Box>
        <Box className='mt-6'>
          <CompanyInfoTextArea
            isEditMode={isEditMode}
            name='reputation'
            label='Reputation'
            maxLength={COMPANY_INFO_TEXT_AREA_MAX_SIZE}
          />
        </Box>
      </Box>
    </form>
  )
}

export default CompanyInfoForm
